import React from 'react';

export default function LiveCalendar() {
  return (
    <section id="live-calendar" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 rounded-full mb-6">
            <i className="ri-calendar-schedule-line text-base"></i>
            <span>ライブスケジュール</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">公演カレンダー</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            東京クラブ参加会場で開催されるライブ公演のスケジュールをカレンダーでご確認いただけます。
            気になる公演の日程をチェックして、ぜひ会場へお越しください。
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6 shadow-sm">
          <div className="w-full overflow-hidden rounded-lg" style={{ minHeight: '600px' }}>
            <iframe
              src="https://calendar.google.com/calendar/embed?src=7b97c3587eedad949528ef8fc5f3d35b855355b137e13bf3e891da97957158%40group.calendar.google.com&ctz=Asia%2FTokyo"
              style={{ border: 0, width: '100%', height: '600px' }}
              title="公演スケジュールカレンダー"
              loading="lazy"
              allow="fullscreen"
            ></iframe>
          </div>
          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0">
                <i className="ri-information-line text-lg"></i>
              </div>
              <div>
                <p className="text-sm text-gray-700 font-medium">カレンダーの使い方</p>
                <p className="text-sm text-gray-500 mt-1">
                  日付をクリックすると公演の詳細が表示されます。月表示・週表示の切り替えも可能です。
                </p>
              </div>
            </div>
            <a
              href="/schedule"
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-list-check text-base"></i>
              スケジュール一覧を見る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
